<script lang="ts" setup>
  definePage({
    meta: {
      public: true,
      layout: 'default',
      title: 'Sina',
    },
    alias: '/c/:id?',
    name: 'root',
    path: '/:id?',
    beforeEnter (to) {
      if (!('id' in to.params)) {
        return true
      }
      const id = to.params.id as unknown as string
      const idPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

      if (!idPattern.test(id)) {
        return
      }

      return true
    },
    end: true,
  })
</script>
<template>
  <chat />
</template>
